import type { AmountString, } from "@bracket/types";
import { formatUnits, } from "viem";
import { effectZero, } from "./effectZero";

export declare type BiToAmountStringOptions = {
	precision?: number;
}


export const biToAmountString = ( amount: bigint, decimals: number, opts: BiToAmountStringOptions = { precision: -1, } ): AmountString => {
	const precision = opts.precision ?? 5;
	const str = effectZeroString(formatUnits(amount, decimals));
	return precision > -1 ? Number(str).toFixed(precision) : str;
}


const effectZeroString = ( str: string ): AmountString => {
	if(str.startsWith("0.00000")) {
		return "0";
	}
	return str;
}
